/** @file ApiContext: the server calls the shell's screens make (null on the memory store dev page). */
import { createContext } from 'react';
import type { EditorApi } from '../store/editorApi';

/** Provided by `App` (the api client through `apiAdapter`); null when the editor runs without a server (`dev/shell`). */
export const ApiContext = createContext<EditorApi | null>(null);
